'use es6';

import { REFERENCE_RECORD } from 'customer-data-filters/filterQueryFormat/DSFieldRecord/formatter/FormatTypes';
import { toDSFieldRecord } from 'customer-data-filters/filterQueryFormat/DSFieldRecord/toDSFieldRecord';
import createDSAdapter from './createDSAdapter';
import http from 'hub-http/clients/apiClient';
import { getFrameworkDataSchemasClient } from 'framework-data-schema-resolvers';
import { Map as ImmutableMap, fromJS } from 'immutable';
import ReferenceRecord from 'reference-resolvers/schema/ReferenceRecord';
import { NOT_SPECIFIED } from 'customer-data-objects/property/AccessLevel';
import { AppObjectTypeIdRegex } from '../../../filterQueryFormat/ObjectTypeId';
const mapPropertyToReferenceRecord = ({
  property,
  permission
}) => new ReferenceRecord({
  id: property.name,
  label: property.label,
  description: property.type,
  referencedObject: fromJS(
  // Add accessLevel field if present, only if HIDDEN or READ_ONLY
  permission !== null && permission !== void 0 && permission.accessLevel && permission.accessLevel !== NOT_SPECIFIED ? Object.assign({}, property, {
    accessLevel: permission.accessLevel
  }) : property)
});
export const mapGroupsToPropertyDSFieldRecords = (assetFamily, results) => {
  const referenceRecords = results
  // Extract property defs
  .flatMap(({
    propertyDefinitions
  }) => propertyDefinitions || [])
  // Map into immutable format
  .reduce((propertyMap, propertyDefinition) => propertyMap.set(propertyDefinition.property.name, mapPropertyToReferenceRecord(propertyDefinition)), ImmutableMap());
  return toDSFieldRecord(referenceRecords, assetFamily, REFERENCE_RECORD);
};
export function makeAppObjectPropertiesAdapter() {
  function isAssetFamilySupported(assetFamily) {
    return AppObjectTypeIdRegex.test(assetFamily);
  }
  function fetch(httpClient, ___, assetFamily) {
    return getFrameworkDataSchemasClient({
      httpClient
    }).then(client => client.properties.getGroups({
      frameworkTypeIdentifier: assetFamily
    }));
  }
  function updater(result, __prevData, assetFamily) {
    return mapGroupsToPropertyDSFieldRecords(assetFamily, result);
  }
  return createDSAdapter({
    fetch,
    getFetcherFromProps: () => http,
    isAssetFamilySupported,
    updater
  });
}
const appObjectPropertiesAdapter = makeAppObjectPropertiesAdapter();
export default appObjectPropertiesAdapter;